import type { CustomCellRendererProps } from "ag-grid-react";
import { clsx } from "clsx";
import { Fragment } from "react";

import style from "../styles/Cell.module.css";
import { extractValueAsArray } from "../utils/tables.ts";
import { StrandCell } from "./StrandCell.tsx";
import { StrandDisplay } from "./StrandDisplay.tsx";

export const StrandListCell = (props: CustomCellRendererProps) => {
  const values = extractValueAsArray(props.value);

  if (values.length === 1) {
    return <StrandCell {...props} value={values[0]} />;
  }

  // Easy ellipses here
  return (
    <div className={clsx(style.cell, style.content_ellipsis)}>
      {values.map((v, index) => (
        <Fragment key={`strand-list-item-${v}-${index}`}>
          <StrandDisplay strand={v} />
          {index < values.length - 1 && ", "}
        </Fragment>
      ))}
    </div>
  );
};
